/* -----------------------------
   ---------- GENERAL ----------
   -----------------------------
*/
import { markRaw } from "vue";
/** Flags representing the 3 different behaviors in Coalesce - Create, Edit, and Delete. */
export var BehaviorFlags;
(function (BehaviorFlags) {
    BehaviorFlags[BehaviorFlags["Create"] = 1] = "Create";
    BehaviorFlags[BehaviorFlags["Edit"] = 2] = "Edit";
    BehaviorFlags[BehaviorFlags["Delete"] = 4] = "Delete";
})(BehaviorFlags || (BehaviorFlags = {}));
/** Utility function for creating the required properties of `EnumType<>` from an array of `EnumValue`  */
export function getEnumMeta(values) {
    return {
        valueLookup: values.reduce((obj, v) => {
            return {
                ...obj,
                [v.strValue]: v,
                [v.value]: v,
            };
        }, {}),
        values: values,
    };
}
/* -----------------------------
   ----- PROPERTY METADATA -----
   -----------------------------
*/
export var HiddenAreas;
(function (HiddenAreas) {
    HiddenAreas[HiddenAreas["List"] = 1] = "List";
    HiddenAreas[HiddenAreas["Edit"] = 2] = "Edit";
})(HiddenAreas || (HiddenAreas = {}));
export function resolvePropMeta(metadata, propOrString, silent = false) {
    const propMeta = typeof propOrString == "string"
        ? metadata.props[propOrString]
        : propOrString;
    if (!propMeta) {
        if (silent)
            return undefined;
        throw `Unknown property ${propOrString}`;
    }
    else if (metadata.props[propMeta.name] !== propMeta) {
        if (silent)
            return undefined;
        throw `Property ${propMeta.name} does not belong to object of type ${metadata.name}`;
    }
    return propMeta;
}
/** Recursively freeze the object, and convert any getter props into props
 * that hold the current value of the getter.
 */
export function solidify(root) {
    const map = new Map();
    function walk(o) {
        if (o == null) {
            return o;
        }
        if (Object.isFrozen(o))
            return o;
        if (map.has(o))
            return map.get(o);
        // Store that we've visited the object.
        // This lets us avoid infinite recursion.
        // We can't use the frozen status to check for recursion
        // because we can't freeze the object until we're done changing its props.
        map.set(o, o);
        for (const prop of Object.getOwnPropertyNames(o)) {
            const value = o[prop];
            if (value != null && typeof value === "object") {
                if (Object.getOwnPropertyDescriptor(o, prop).get) {
                    // The prop is defined as a getter; eval it and store the static value.
                    // The whole point of the getters is to make the metadata easier to generate,
                    // since we can reference other types before those types are declared,
                    // but they're not needed at runtime.
                    Object.defineProperty(o, prop, { value: walk(value) });
                }
                else {
                    o[prop] = walk(value);
                }
            }
        }
        return Object.freeze(markRaw(o));
    }
    return walk(root);
}
